import React, { Component } from 'react';
import * as Features from '@/Feature/FeatureActions';
const FEATURES_COMPONENTS_MAP = [
  {
    id: 'HIGHLIGHT_TITLES',
    component: Features.HighlightTitles
  }, {
    id: 'HIGHLIGHT_LINKS',
    component: Features.HighlightLinks
  }, {
    id: 'TOOL_TIP',
    component: Features.ToolTip
  }, {
    id: 'FONT_SIZE',
    component: Features.FontResize
  }, {
    id: 'BACKGROUND_COLOR',
    component: Features.BackgroundColor
  }, {
    id: 'FONT_COLOR',
    component: Features.FontColor
  }, {
    id: 'FONT_FAMILY',
    component: Features.FontFamily
  }, {
    id: 'CURSOR_STYLE',
    component: Features.CursorStyle
  }, {
    id: 'SCREEN_FILTERS',
    component: Features.ScreenFilters
  }
]

const getComponentById = (id) => {
  for (let feature of FEATURES_COMPONENTS_MAP) {
    if (feature.id === id) {
      return feature.component;
    }
  }
}

export { FEATURES_COMPONENTS_MAP, getComponentById };


// WEBPACK FOOTER //
// ./src/constants/featuresComponentsMap.js